export default __webpack_public_path__ + "static/media/ic_roll up_24px.bebdd4fa.svg";